import { AdminTemplateModuleStore, UserGetMe } from './StoreTypes'

const mutations = {
  UPDATE_USER_INFO(state: AdminTemplateModuleStore, userObject:UserGetMe): void {
    state.user = userObject
  },
  SET_FIELD_TO_ACCOUNT_DATA(state: AdminTemplateModuleStore, field: Record<string, any>): void {
    if (state.user && state.user.data) {
      const rootObjectPath = state.accountDataRoot
      const resultObject:any = {}

      if (rootObjectPath) {
        const rootObjectModel = state.user.data[rootObjectPath]
        Object.assign(resultObject, { [rootObjectPath]: {} })

        Object.assign(resultObject[rootObjectPath], rootObjectModel, field)
      } else {
        Object.assign(resultObject, field)
      }

      Object.assign(state.user.data, resultObject)
    }
  },
  UPDATE_ACCOUNT_DATA(state: AdminTemplateModuleStore, accountData: Record<string, any>): void {
    if (state.user && state.user.data) {
      state.user.data = accountData
    }
  },
  SET_ACCOUNT_DATA_ROOT(state: AdminTemplateModuleStore, rootPath: string | null): void {
    state.accountDataRoot = rootPath
  },
  TOGGLE_GLOBAL_LOADER(state: AdminTemplateModuleStore, loaderState:boolean): void {
    state.globalLoader = loaderState
  },
  // project config
  LOADED(state: AdminTemplateModuleStore): void {
    state.loaded = true
  },
  SET_LANGUAGES(state: AdminTemplateModuleStore, { languageCodes }: {languageCodes: any}): void {
    state.languageCodes = languageCodes
  },
  SET_ROUTES(state: AdminTemplateModuleStore, routes:any): void {
    state.routes = routes
  },

  SET_PROJECT_CONFIG(state: AdminTemplateModuleStore, { config }: {config:any}): void {
    state.applicationConfig = config
  },
  TOGGLE_SAVE_CONFIG_BUTTON(state: AdminTemplateModuleStore, payload:boolean): void {
    if (state.applicationConfig && state.applicationConfig.meta && state.applicationConfig.meta.isSaveButtonVisible !== undefined) {
      state.applicationConfig.meta.isSaveButtonVisible = payload
    }
  },
  SET_RUNTIME_CONFIG(state: AdminTemplateModuleStore, payload:any): void {
    state.runtime_config = payload
  },
  SET_SAVE_CONFIG_BUTTON_CALLBACK(state: AdminTemplateModuleStore, callback:() => any): void {
      state.saveButtonCallback = callback
  },
  RESET_SAVE_CONFIG_BUTTON_CALLBACK(state: AdminTemplateModuleStore): void {
      state.saveButtonCallback = null
  },
  TOGGLE_MENU_RELOAD(state: AdminTemplateModuleStore): void {
    state.sidebarMenuReloadToggle = !state.sidebarMenuReloadToggle
  },
  TOGGLE_DRAWER(state: AdminTemplateModuleStore): void {
    state.menuDrawerToggle = !state.menuDrawerToggle
  }
}

export default mutations
